module.exports = __webpack_public_path__ + "media/career/03-benefit-users-wm-d0d733f7.svg";